import CheetahIcon, { CheetahIconPack } from '@/components/atomic/atoms/CheetahIcon'
import { cn } from '@/shared/utils/class-name-utils'

interface Props {
  rating: number
  digit?: number
  textClassName?: string
  testId?: string
}

export const StarRating = ({ rating, digit = 1, textClassName, testId }: Props) => {
  const formattedRating = rating.toFixed(digit)

  return (
    <span className="flex items-center">
      <CheetahIcon name={CheetahIconPack.STAR} width={12} height={12} className="mr-[4px] w-[12px] h-[12px]" />
      <span className={cn('text-[11px] font-normal leading-[16px] tracking-[0]', textClassName)} data-testid={testId}>
        {formattedRating}
      </span>
    </span>
  )
}
